import React, { useState } from "react";
import { auth } from "./firebaseConfig";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { db } from "./firebaseConfig";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isRegisterHovered, setIsRegisterHovered] = useState(false);
  const [isBackHovered, setIsBackHovered] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    try {
      // Create the user with email and password
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      console.log("User created:", user.email);

      // Save user details in Firestore
      await setDoc(doc(db, "users", user.uid), {
        username: username, // Save the username
        email: email,
        role: "student", // Default role for new users
        extraTimePercentage: 0, // Set extra time percentage to 0 by default
      });

      console.log("User details saved to Firestore");
      alert("Registration successful! You can now log in.");

      navigate("/"); // Redirect to login page
    } catch (error) {
      console.error("Error during sign-up:", error.message);
      alert("Error during registration: " + error.message);
    }
  };

  const containerStyle = {
    backgroundImage: "linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('/green1.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "100vh",
    padding: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "'Poppins', 'Segoe UI', Arial, sans-serif",
  };

  const tileStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    borderRadius: "16px",
    padding: "40px",
    margin: "20px",
    maxWidth: "420px",
    width: "100%",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)",
    textAlign: "center",
    backdropFilter: "blur(10px)",
    animation: "fadeIn 1.2s ease-in-out",
  };

  const logoContainerStyle = {
    display: "flex",
    justifyContent: "center",
    marginBottom: "24px",
  };

  const logoStyle = {
    width: "110px",
    filter: "drop-shadow(0 4px 6px rgba(45, 106, 79, 0.2))",
    transition: "transform 0.3s ease",
    animation: "pulse 2s infinite ease-in-out",
  };

  const titleStyle = {
    color: "#2d6a4f",
    marginBottom: "25px",
    fontSize: "26px",
    fontWeight: "600",
    letterSpacing: "0.2px",
    textShadow: "0 1px 2px rgba(0,0,0,0.05)",
  };

  const inputContainerStyle = {
    position: "relative",
    marginBottom: "16px",
  };

  const inputStyle = {
    padding: "14px 16px",
    width: "100%",
    border: "1.5px solid #e0e0e0",
    borderRadius: "8px",
    fontSize: "15px",
    transition: "all 0.3s ease",
    boxSizing: "border-box",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    outline: "none",
  };

  const buttonStyle = {
    backgroundColor: isRegisterHovered ? "#1e5739" : "#2d6a4f",
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    padding: "14px 20px",
    marginTop: "20px",
    cursor: "pointer",
    width: "100%",
    fontSize: "16px",
    fontWeight: "600",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 6px rgba(45, 106, 79, 0.2)",
    letterSpacing: "0.5px",
  };

  const backButtonStyle = {
    backgroundColor: isBackHovered ? "#5a6268" : "#6c757d",
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    padding: "14px 20px",
    marginTop: "16px",
    cursor: "pointer",
    width: "100%",
    fontSize: "15px",
    fontWeight: "500",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 6px rgba(108, 117, 125, 0.2)",
    letterSpacing: "0.5px",
  };

  return (
    <div style={containerStyle}>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
          input:focus {
            border-color: #2d6a4f;
            box-shadow: 0 0 0 3px rgba(45, 106, 79, 0.15);
            background-color: #ffffff;
          }
        `}
      </style>
      <div style={tileStyle}>
        <div style={logoContainerStyle}>
          <img
            src="/newlogo.png"
            alt="AI AutoMarker logo"
            style={logoStyle}
          />
        </div>
        <h1 style={titleStyle}>Create Account</h1>
        <form onSubmit={handleSignUp}>
          <div style={inputContainerStyle}>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={inputStyle}
              required
            />
          </div>
          <div style={inputContainerStyle}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={inputStyle}
              required
            />
          </div>
          <div style={inputContainerStyle}>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={inputStyle}
              required
            />
          </div>
          <div style={inputContainerStyle}>
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              style={inputStyle}
              required
            />
          </div>
          <button 
            type="submit" 
            style={buttonStyle}
            onMouseEnter={() => setIsRegisterHovered(true)}
            onMouseLeave={() => setIsRegisterHovered(false)}
          >
            Register
          </button>
        </form>
        <button
          style={backButtonStyle}
          onClick={() => navigate("/")}
          onMouseEnter={() => setIsBackHovered(true)}
          onMouseLeave={() => setIsBackHovered(false)}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default SignUp;
